<div class="wrapperi">
    <div class="top-banner mt-4 ps-3 pe-3">
        <div class="col-12 row m-0 h-100">
            <div class="col-12 bg-cover relative  d-flex align-items-center padding-top-banner">
                <div class="col-12 row m-0">
                    <div class="col-6 d-flex flex-column justify-content-center">
                        <div class=" ">
                            <p class="banner-title-text">Listat</p>
                            <p class="banner-subtitle-text">Tallenna tai muokkaa hakijalistojasi. Voit myös jakaa listoja kollegoidesi kanssa.</p>
                            <button *ngIf="!shared_view" class="btn btn-formed-main-blue" data-bs-target="#exampleModalToggle2"
                            data-bs-toggle="modal" data-bs-dismiss="modal" >
                                Luo lista
                            </button>
                        </div>
                    </div>
                    <div class="col-6 justify-content-end d-flex">

                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 ps-2 pe-2 pb-4 pt-0">
        <div class="ps-2 pt-3">
            <div class="d-flex justify-content-between align-items-center">
                <div class="">
                    <p class="semiboldtextblue90024">Sinun listasi <span
                        class="semiboldtextblue50024 ms-2">{{employer_lists.length}}</span></p>
                </div>
                <div class="d-inline-flex">
                    <button [ngClass]="shared_view ? 'btn-formed-main-blue' : 'btn-formed-hollow'" class="btn me-2" (click)="routeShared()" >Jaetut listat</button>
                    <button [ngClass]="shared_view ? 'btn-formed-hollow' : 'btn-formed-main-blue'" class="btn" routerLink="/{{businessID}}/lists" >Minun listani</button>
                </div>
            </div>
        </div>
        <div class="" *ngIf="employer_lists && employer_lists.length > 0; else no_lists">
            <div class="row m-0 p-0">
                <div class="col-md-6 col-lg-6 col-xl-6 ps-1 mt-3" routerLink="/{{businessID}}/lists/list/{{data._id}}" *ngFor="let data of employer_lists">
                    <div class="" *ngIf="true;else banner_template">
                        <div class="formed-border-radius relative card-body formed-shadow formed-shadow p-20 bg-w">
                            <div class="text-container">
                                <p class="semiboldtextblue90020">{{data.name}}</p>

                            </div>
                            <div class="icons-container mt-3">
                                <div class="d-flex">
                                    <div class="icon-container-lists d-flex justify-content-center me-2"
                                        style="width: 20px">
                                        <img src="../../assets/icons/bookmark_icon.svg" width="12" alt="">
                                    </div>
                                    <div class="name-container-lists">
                                        <p class="normaltextgray90016 f-os mb-0"><span
                                                class="me-1">{{data.profiles.length}}</span>tallennettua profiilia</p>
                                    </div>
                                </div>
                                <div class="d-flex mt-2">
                                    <div class="icon-container-lists d-flex justify-content-center me-2"
                                        style="width: 20px">
                                        <img src="../../assets/icons/calendar_dark_blue.svg" width="16" alt="">
                                    </div>
                                    <div class="name-container-lists">
                                        <p class="normaltextgray90016 f-os mb-0">Viimeksi muokattu {{data.editedDate | formateDate}}</p>
                                    </div>
                                </div>
                                <div class="d-flex mt-2 w-100">
                                    <div class="d-flex justify-content-between flex-grow-1">
                                        <div class="d-flex" *ngIf="data.can_be_seen_by_others_in_same_business">
                                            <div class="icon-container-lists d-flex justify-content-center me-2"
                                                style="width: 20px">
                                                <img src="../../assets/icons/people.svg" width="16" alt="">
                                            </div>
                                            <div class="name-container-lists">
                                                <p class="normaltextgray90016 f-os mb-0"><strong>Kaikilla</strong>
                                                    organisaatiossasi on pääsy</p>
                                            </div>
                                        </div>
                                        <div class="d-flex" *ngIf="!data.can_be_seen_by_others_in_same_business">
                                            <div class="icon-container-lists d-flex justify-content-center me-2"
                                                style="width: 20px">
                                                <img src="../../assets/icons/lock_icon.svg" width="16" alt="">
                                            </div>
                                            <div class="name-container-lists">
                                                <p class="normaltextgray90016 f-os mb-0"><strong>Vain sinulla</strong> on pääsy</p>
                                            </div>
                                        </div>
                                        <div class="">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <ng-template #banner_template>
                        <div (click)="routeAd(opening)"
                            class="h-100 w-100 pointer formed-shadow relative formed-border-radius formed-shadow"
                            style="cursor: pointer;background: url({{opening.image}}); background-size: cover">
                            <div class="pointer h-100 w-100"></div>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
        <ng-template #no_lists>
            <div class=" mt-4 ps-2 pe-2">
                <div class="bg-f-w formed-shadow col-12 row pb-4 mb-4 m-0" *ngIf="!isLoading">
                    <div class="col-2">

                    </div>
                    <div class="col-12 col-lg-8">
                        <div class="bg-f-w p-4">
                            <div class="justify-content-center d-flex">
                                <img src="../../assets/images/no_search_found.png" height="270" alt="">
                            </div>
                            <div class="p-4">
                                <p class="semiboldtextblue24 text-center mt-4">
                                    Ei listoja
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-2">

                    </div>
                </div>
            </div>


        </ng-template>
    </div>
</div>


<div class="modal fade" id="exampleModalToggle2" aria-hidden="true" aria-labelledby="exampleModalToggleLabel2"
    tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="">
                <div class="p-4 d-flex justify-content-between">
                    <div class="">
                        <div class="d-inline-flex">
                            <div class="icon-cont">
                                <img src="../../assets/icons/bookmark_filled.svg" width="14" alt="">
                            </div>
                            <div class="ms-3 ">
                                <h5 class="semiboldtextblue90024" id="exampleModalLabel">Luo uusi lista</h5>
                            </div>
                        </div>
                    </div>
                    <div class="flex-end">
                        <button id="close-confirm-modal" type="button" class="btn-close" data-bs-dismiss="modal"
                            aria-label="Close">
                            <img src="../../assets/icons/close_icon.svg" width="15" alt="">
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-body">
                <div class="">
                    <input type="text" placeholder="Otsikko*" id="list-title" class="form-control">
                </div>
                <div class="mt-2">
                    <input type="text" placeholder="Kuvaus*" id="list-description" class="form-control">
                </div>

                <div class="accordion rekruu-accordion p-10 accordion-flush mt-2" id="accordionFlushExample">
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="flush-headingOne">
                            <button class="accordion-button rekruu-accordion-button collapsed" type="button"
                                data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false"
                                aria-controls="flush-collapseOne">
                                Valitse kenellä on oikeus katsoa listaa
                            </button>
                        </h2>
                        <div id="flush-collapseOne" class="accordion-collapse collapse"
                            aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                            <div class="accordion-body">
                                <div class="pointer" *ngFor="let data of rights"
                                    [ngClass]="!data.selected ? '' : 'bg-selected-acc-item'"
                                    (click)="selectRight(data)">
                                    <div class="d-flex justify-content-between p-10 align-items-center">
                                        <div class="d-inline-flex">
                                            <div class="icon-container-acc icon-width me-2">
                                                <img src="{{data.icon_src}}" class="" alt="">
                                            </div>
                                            <div class="name">
                                                <p class="normaltextblue90016 mb-0">
                                                    <strong>{{data.highlighted}}</strong>{{data.normal}}</p>
                                            </div>
                                        </div>
                                        <div class="check-icon-container" *ngIf="data.selected">
                                            <img src="../../assets/icons/check_icon.svg" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-12 p-10 row m-0 mb-20 pt-0">
                <div class="col-6 d-flex ps-1">
                    <button class="btn btn-formed-hollow w-100" id="close_create_new_list"
                        data-bs-dismiss="modal">Peruuta</button>
                </div>
                <div class="col-6 pe-1">
                    <button class="btn btn-formed-main-blue w-100" (click)="createANewList()">Tallenna</button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal Check before deleting offer -->
<button data-bs-toggle="modal" id="list-created" data-bs-target="#list-created-modal" style="display:none"></button>
<div class="modal fade" id="list-created-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="">
                <div class="ps-4 pe-4 pt-4 d-flex justify-content-between">
                    <div class="">
                        <div class="d-inline-flex">
                            <div class="icon-cont">
                                <img src="../../assets/icons/check_icon_filled.svg" width="25" alt="">
                            </div>
                            <div class="ms-3 ">
                                <h5 class="semiboldtextblue90024" id="exampleModalLabel">Lista luotu</h5>
                            </div>
                        </div>
                    </div>
                    <div class="flex-end">
                        <button id="close-list-created" type="button" class="btn-close" data-bs-dismiss="modal"
                            aria-label="Close">
                            <img src="../../assets/icons/close_icon.svg" width="15" alt="">
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-body">
                <p class="normaltextblue90016 f-os">Lista on onnistuneesti luotu</p>

                <div class="col 12 row m-0 mt-20">
                    <div class="">
                        <button class="btn btn-formed-main-blue w-100" data-bs-dismiss="modal" >Selvä</button>
                    </div>
                </div>


            </div>
        </div>
    </div>
</div>